export default "__VITE_ASSET__9PDUBYwJ__"